module.exports = __webpack_public_path__ + "media/images/icon__edit--rb-red-b05b61fde67bfbf6c379e5ac2cf4a386.png";